import React, { Component } from 'react';
import setLoaderAction from "./loaderAction";
import types from "../actionTypes";
import { isSessionValid } from "./profileAction";
import * as toastAction from "../actions/toastAction";
import * as apiServices from "../../services/apiServices";
import apiConfig, {
  DEFAULT_ERROR_MESSAGE,
  ERROR_TIMEOUT,
  INVALID_SESSION,
  MODAL_SIZE,
} from "../../App.config";
import { closeRemoveModal, openSetModal } from "./modalActions";
import { setSuccessMessage } from "./commonAction";
import { getAllPendingApplications } from "./notificationAction";
import AttachmentDescription from "../../containers/Std/AttachmentDescription";

/************************************ ACTIONS ****************************************/
function setCCMEmployeeStatement(ccmEmployeeStatement) {
  return {
    type: types.SET_CCM_STATEMENT,
    ccmEmployeeStatement
  }
}

function setAccomodationApplicantsAction(applicant) {

  return {
    type: types.SET_CCM_APPLICANTS,
    applicant,
  };
}

function setTotalRowsAction(totalRows) {
  return {
    type: types.SET_CCM_PAGE_ROWS,
    totalRows,
  };
}

function setCurretPageAction(currentPage) {
  return {
    type: types.SET_CCM_PAGE_NO,
    currentPage,
  };
}

function setPageSizeAction(pageSize) {
  return {
    type: types.SET_CCM_PAGE_SIZE,
    pageSize,
  };
}

function setMinimumFormStepAction(minSteps) {
  return {
    type: types.SET_CCM_MIN_STEPS,
    minSteps,
  };
}

function setMaximumFormStepAction(maxSteps) {
  return {
    type: types.SET_CCM_MAX_STEPS,
    maxSteps,
  };
}

function setCurrentFormStepAction(step) {
  return {
    type: types.SET_CCM_CURRENT_STEP,
    step,
  };
}

function setIsAddedAction(isAdded) {
  return {
    type: types.SET_CCM_IS_ADDED,
    isAdded,
  };
}

function setAccomodationPdfLinkAction(accomodationFormPdfLink) {
  return {
    type: types.SET_CCM_FORM_PDF,
    accomodationFormPdfLink,
  };
}

function setAcmdCaseStatusAction(caseStatus) {
  return {
    type: types.SET_CCM_CASE_STATUS,
    caseStatus,
  };
}

function setAcmdCaseStatusModifiedAction(caseStatusModified) {
  return {
    type: types.SET_CASE_STATUS_MODIFIED_CCM,
    caseStatusModified,
  };
}

/// Case Status pagination action
function setAcmdCaseStatusTotalRowsAction(totalRows) {
  return {
    type: types.SET_CCM_PAGE_ROWS, //SET_ACMD_CASESTATUS_TOTAL_ROWS
    totalRows,
  };
}

function setAttachmentAction(attachment) {
  return {
    type: types.SET_ATTACHMENT_CCM,
    attachment,
  };
}



/************************************ ACTION CREATORS ****************************************/

//Setting form step count
//Setting form step count
export const resetCCMEmployeeStatement = () => (dispatch) => {
  dispatch(setCCMEmployeeStatement([]));
}

export const setAttachment = (attachment) => (dispatch) => {
  dispatch(setAttachmentAction(attachment));
};

export const resetState = () => (dispatch) => {
  dispatch(setCurrentFormStep(1));
  //dispatch(setPendingApplications(undefined));
  //dispatch(setAirEmployeeStatement(undefined));
};

export const setCurrentPage = (currentPage) => (dispatch) => {
  dispatch(setCurretPageAction(currentPage));
};

export const setPageSize = (pageSize) => (dispatch) => {
  dispatch(setPageSizeAction(pageSize));
};

export const setMaximumFormStep = (maxCount) => (dispatch) => {
  dispatch(setMaximumFormStepAction(maxCount));
};

export const setMinimumFormStep = (minCount) => (dispatch) => {
  dispatch(setMinimumFormStepAction(minCount));
};

export const setCurrentFormStep = (stepCount) => (dispatch) => {
  dispatch(setCurrentFormStepAction(stepCount));
};

export const resetIsAdded = (isAdded) => (dispatch) => {
  dispatch(setIsAddedAction(isAdded));
};

export const resetAccomodationApplicationUrl = () => (dispatch) => {
  dispatch(setAccomodationPdfLinkAction(undefined));
};

export const getCaseStatus = (searchKey, pagination) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getAcmdCaseStatus(searchKey, pagination)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        // dispatch(setCaseStatusModifiedAction(data.caseStatusDetails));
        dispatch(setAcmdCaseStatusAction(data.caseStatusDetails));
        dispatch(setAcmdCaseStatusTotalRowsAction(data.pagination.totalRows));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getAccomodationApplicants = (pagination, searchKey, profileReducer) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getAccomodationApplicants(pagination, searchKey, profileReducer)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(setTotalRowsAction(data.pagination.totalRows));
        dispatch(
          setAccomodationApplicantsAction(
            data.employeeList
          )
        );
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
}

export const addCCMStatement = (accomodationData, managerId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .addCCMStatement(accomodationData)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        dispatch(
          setAccomodationPdfLinkAction(
            // data?.ersFormPDF?.fileUploadPath?.replace("~/", apiConfig.BASEURL)
            data?.ersFormPDF?.fileUploadPath
          )
        );
        dispatch(setSuccessMessage(data.successMessage));
        dispatch(setIsAddedAction(true));
        dispatch(getAllPendingApplications(managerId));
        // dispatch(toastAction.showSuccessMessage(true, data.successMessage));
        // setTimeout(() => {
        //   dispatch(toastAction.showSuccessMessage(false, ""));
        // }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const getCCMEmployeeStatement = (employeeInformationId) => (dispatch) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .getCCMEmployeeStatement(employeeInformationId)
    .then(({ data }) => {
      dispatch(setLoaderAction(false));
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setCCMEmployeeStatement(data));
        setTimeout(() => {
          dispatch(toastAction.showSuccessMessage(false, ""));
        }, ERROR_TIMEOUT);
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};

export const uploadFiles = (file, allFiles, props) => (dispatch, getState) => {
  dispatch(setLoaderAction(true));
  return apiServices
    .uploadFiles(file)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        let attachmentData = [
          ...allFiles,
          {
            // fullFilePath: data?.fileUploadData?.path?.replace(
            //   "~/",
            //   apiConfig.BASEURL
            // ),
            fullFilePath: data?.fileUploadData?.path,
            attachmentDescription: "",
            ...data.fileUploadData,
          },
        ];

        dispatch(setAttachmentAction(attachmentData));
        dispatch(openSetModal(<AttachmentDescription {...props}
          index={getState()?.ccmReducer?.attachment.length - 1}
          attachmentDescription={getState()?.ccmReducer?.attachment.attachmentDescription}
          attachment={getState()?.ccmReducer?.attachment} />, MODAL_SIZE.MODAL_SM, true));
      } else {

        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
        else {

          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};


export const removeFiles = (filePath, isDocs, index, allAttachments) => (
  dispatch
) => {
  dispatch(setLoaderAction(true));
  filePath = filePath.replace(apiConfig.BASEURL, "/");
  return apiServices
    .removeFile(filePath, isDocs)
    .then(({ data }) => {
      if (dispatch(isSessionValid(data.errorMessage))) {
        return;
      }
      if (data.isTransactionSucceed) {
        dispatch(setLoaderAction(false));
        let updatedAttachment = [];
        updatedAttachment = [...allAttachments];
        updatedAttachment.splice(index, 1);
        dispatch(setAttachmentAction(updatedAttachment));
      } else {
        if (data.errorMessage) {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, data.errorMessage));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        } else {
          dispatch(setLoaderAction(false));
          dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
          setTimeout(() => {
            dispatch(toastAction.showErrorMessage(false, ""));
          }, ERROR_TIMEOUT);
        }
      }
    })
    .catch((error) => {
      dispatch(setLoaderAction(false));
      dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
      setTimeout(() => {
        dispatch(toastAction.showErrorMessage(false, ""));
      }, ERROR_TIMEOUT);
    });
};


